
import { Placement } from '@post-office/placements-frontend/jira-navbar-assets-app-section';
export default Placement;
